<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">
      <!--
      <span>
        <mat-form-field matTooltip="Ranger Id" [matTooltipDisabled]="disabledTooltip(this.rangerId)">
          <mat-label i18n="@@type.Ranger.rangerId">Ranger Id</mat-label>
          <input matInput formControlName="rangerId" id="rangerId"              
              (ngModelChange)="rangerIdChanging($event)" [(ngModel)]="item.rangerId"              
              (ngModelChange)="rangerIdChanged($event)" #rangerId              
              type="number" placeholder="Ranger Id">
        </mat-form-field>
      </span>
    -->
      <span>
        <mat-form-field matTooltip="Select a Ranger Source from the list"
          [matTooltipDisabled]="disabledTooltip(this.rangerSource)" class="crud-item-input-wider">
          <mat-label i18n="@@type.Ranger.rangerSource">Email</mat-label>
          <input matInput [matAutocomplete]="rangerSourceAutocomplete" formControlName="rangerSource" id="rangerSource"
            (ngModelChange)="rangerSourceChanging($event)" [(ngModel)]="item.emailOrRangerSource"
            (ngModelChange)="rangerSourceChanged($event)" #rangerSource>
          <mat-autocomplete id="rangerSourceAutocomplete" #rangerSourceAutocomplete [displayWith]="rangerSourceDisplay">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let rangerSource of rangerSourceSelectionList | async" [value]="rangerSource">
              {{rangerSourceDisplay(rangerSource)}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </span>
      <span>
        <mat-form-field matTooltip="Name" [matTooltipDisabled]="disabledTooltip(this.name)"
          class="crud-item-input-wider">
          <mat-label i18n="@@type.Ranger.name">Name</mat-label>
          <input matInput formControlName="name" id="name" (ngModelChange)="nameChanging($event)"
            [(ngModel)]="item.name" (ngModelChange)="nameChanged($event)" #name maxlength="255" placeholder="Name">
        </mat-form-field>
      </span>
      <span>
        <div class="crud-editor-warning-list">
          <div *ngFor="let warning of sourceValidationErrors(['rangerSourceNotExists',
                                                              'rangerSourceDateInvalid',
                                                              'rangerSourceDateValidRangerClosed',
                                                              'rangerSourceEmailInvalid',
                                                              'rangerSourceNameMismatch'])"
            class="crud-editor-warning">{{warning}}
          </div>
        </div>
      </span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Select a Business Unit from the list"
          [matTooltipDisabled]="disabledTooltip(this.businessUnit)">
          <mat-label i18n="@@type.Ranger.businessUnit">Business Unit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnit" (ngModelChange)="businessUnitChanging($event)"
            [(ngModel)]="item.businessUnit" (ngModelChange)="businessUnitChanged($event)" #businessUnit
            placeholder="Business Unit" [compareWith]="businessUnitCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnit?.buId}} - {{businessUnit?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
      <span>
        <mat-form-field matTooltip="Select a Cost Centre from the list"
          [matTooltipDisabled]="disabledTooltip(this.costCentre)" class="crud-item-input-wider">
          <mat-label i18n="@@type.Ranger.costCentre">Cost Centre</mat-label>
          <mat-select formControlName="costCentre" id="costCentre" (ngModelChange)="costCentreChanging($event)"
            [(ngModel)]="item.costCentre" (ngModelChange)="costCentreChanged($event)" #costCentre
            placeholder="Cost Centre" [compareWith]="costCentreCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let costCentre of costCentreSelectionList" [value]="costCentre">
              {{costCentre?.ccId}} - {{costCentre?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
      <span>
        <mat-form-field matTooltip="Select a Status from the list" [matTooltipDisabled]="disabledTooltip(this.status)">
          <mat-label i18n="@@type.Ranger.status">Status</mat-label>
          <mat-select formControlName="status" id="status" (ngModelChange)="statusChanging($event)"
            [(ngModel)]="item.status" (ngModelChange)="statusChanged($event)" #status placeholder="Status">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let status of statusSelectionList" [value]="status.code">
              {{status.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      </div>

      <mat-divider></mat-divider>

    <div class="crud-item-section">
      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary" matTooltip="Cannot change volunteer status when a ranger is assigned firearms" [matTooltipDisabled]="item.currentFirearmCount <= 0"
              formControlName="volunteerRanger" id="volunteerRanger"              
              (ngModelChange)="volunteerRangerChanging($event)" [(ngModel)]="item.volunteerRanger"              
              (ngModelChange)="volunteerRangerChanged($event)" #volunteerRanger i18n="@@type.Ranger.volunteerRanger">Volunteer Ranger</mat-slide-toggle>        
        </span>
      </span>
      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
              formControlName="provisionalRanger" id="provisionalRanger"              
              (ngModelChange)="provisionalRangerChanging($event)" [(ngModel)]="item.provisionalRanger"              
              (ngModelChange)="provisionalRangerChanged($event)" #provisionalRanger i18n="@@type.Ranger.provisionalRanger">Provisional Ranger</mat-slide-toggle>        
        </span>
      </span>

       <span>
        <span *ngIf="isWildlifeManagerRangerAvailable()">
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
              formControlName="wildlifeManagerRanger" id="wildlifeManagerRanger"              
              (ngModelChange)="wildlifeManagerRangerChanging($event)" [(ngModel)]="item.wildlifeManagerRanger"              
              (ngModelChange)="wildlifeManagerRangerChanged($event)" #wildlifeManagerRanger i18n="@@type.Ranger.wildlifeManagerRanger"> Wildlife Manager Ranger          </mat-slide-toggle>        
        </span>
      </span>

      <span>
        <button mat-raised-button color="primary" (click)="copyFromSource()" i18n="@@actions.Ranger.copyFromSource" [disabled]="!isCopyFromSourceEnabled()">Copy from WMS</button>
      </span>

      <div class="crud-item-section">
        <span>
          <div class="crud-editor-warning-list">
            <div *ngFor="let warning of sourceValidationErrors(['rangerBusinessUnitMismatch',
                                                              'rangerCostCentreMismatch'])"
              class="crud-editor-warning">{{warning}}
            </div>
          </div>
        </span>
      </div>
    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Firearms Authority Issue Date" [matTooltipDisabled]="disabledTooltip(this.firearmsAuthorityIssueDate)">
          <mat-label i18n="@@type.Ranger.firearmsAuthorityIssueDate">Firearms Authority Issue Date</mat-label>
          <input matInput formControlName="firearmsAuthorityIssueDate" id="firearmsAuthorityIssueDate"              
              (ngModelChange)="firearmsAuthorityIssueDateChanging($event)" [(ngModel)]="item.firearmsAuthorityIssueDate"              
              (ngModelChange)="firearmsAuthorityIssueDateChanged($event)" #firearmsAuthorityIssueDate              
              [matDatepicker]="firearmsAuthorityIssueDateDatePicker" placeholder="Firearms Authority Issue Date">
          <mat-datepicker-toggle matSuffix [for]="firearmsAuthorityIssueDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #firearmsAuthorityIssueDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>


      <span>
        <mat-form-field matTooltip="Firearms Authority Expiry Date" [matTooltipDisabled]="disabledTooltip(this.firearmsAuthorityExpiryDate)">
          <mat-label i18n="@@type.Ranger.firearmsAuthorityExpiryDate">Firearms Authority Expiry Date</mat-label>
          <input matInput formControlName="firearmsAuthorityExpiryDate" id="firearmsAuthorityExpiryDate"              
              [ngModel]="item.firearmsAuthorityExpiryDate" #firearmsAuthorityExpiryDate              
              [matDatepicker]="firearmsAuthorityExpiryDateDatePicker" placeholder="Firearms Authority Expiry Date"              
              disabled>
          <mat-datepicker-toggle matSuffix [for]="firearmsAuthorityExpiryDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #firearmsAuthorityExpiryDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>
    </div>
    
    <mat-divider></mat-divider>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Select a Police Contact from the list" [matTooltipDisabled]="disabledTooltip(this.policeContact)" class="crud-item-input-verywide">
          <mat-label i18n="@@type.Ranger.policeContact">Police Contact</mat-label>
          <mat-select formControlName="policeContact" id="policeContact"              
              (ngModelChange)="policeContactChanging($event)" [(ngModel)]="item.policeContact"              
              (ngModelChange)="policeContactChanged($event)" #policeContact              
              placeholder="Police Contact" [compareWith]="policeContactCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let policeContact of policeContactSelectionList" [value]="policeContact" [matTooltip]="policeContactDisplay(policeContact)">
              {{policeContactDisplay(policeContact)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </div>
    
    <mat-divider></mat-divider>
    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Addr1" [matTooltipDisabled]="disabledTooltip(this.addr1)"
          class="crud-item-input-wide">
          <mat-label i18n="@@type.Ranger.addr1">Addr1</mat-label>
          <input matInput formControlName="addr1" id="addr1" (ngModelChange)="addr1Changing($event)"
            [(ngModel)]="item.addr1" (ngModelChange)="addr1Changed($event)" #addr1 maxlength="255" placeholder="Addr1">
        </mat-form-field>
      </span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Addr2" [matTooltipDisabled]="disabledTooltip(this.addr2)"
          class="crud-item-input-wide">
          <mat-label i18n="@@type.Ranger.addr2">Addr2</mat-label>
          <input matInput formControlName="addr2" id="addr2" (ngModelChange)="addr2Changing($event)"
            [(ngModel)]="item.addr2" (ngModelChange)="addr2Changed($event)" #addr2 maxlength="255" placeholder="Addr2">
        </mat-form-field>
      </span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Addr3" [matTooltipDisabled]="disabledTooltip(this.addr3)"
          class="crud-item-input-wide" class="crud-item-input-wide">
          <mat-label i18n="@@type.Ranger.addr3">Addr3</mat-label>
          <input matInput formControlName="addr3" id="addr3" (ngModelChange)="addr3Changing($event)"
            [(ngModel)]="item.addr3" (ngModelChange)="addr3Changed($event)" #addr3 maxlength="255" placeholder="Addr3">
        </mat-form-field>
      </span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Town" [matTooltipDisabled]="disabledTooltip(this.town)"
          class="crud-item-input-wider">
          <mat-label i18n="@@type.Ranger.town">Town</mat-label>
          <input matInput formControlName="town" id="town" (ngModelChange)="townChanging($event)"
            [(ngModel)]="item.town" (ngModelChange)="townChanged($event)" #town maxlength="255" placeholder="Town">
        </mat-form-field>
      </span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="County" [matTooltipDisabled]="disabledTooltip(this.county)"
          class="crud-item-input-wider">
          <mat-label i18n="@@type.Ranger.county">County</mat-label>
          <input matInput formControlName="county" id="county" (ngModelChange)="countyChanging($event)"
            [(ngModel)]="item.county" (ngModelChange)="countyChanged($event)" #county maxlength="255"
            placeholder="County">
        </mat-form-field>
      </span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Postcode" [matTooltipDisabled]="disabledTooltip(this.postcode)">
          <mat-label i18n="@@type.Ranger.postcode">Postcode</mat-label>
          <input matInput formControlName="postcode" id="postcode" (ngModelChange)="postcodeChanging($event)"
            [(ngModel)]="item.postcode" (ngModelChange)="postcodeChanged($event)" #postcode maxlength="8"
            placeholder="Postcode">
        </mat-form-field>
      </span>
    </div>
      <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Mobile Phone Number" [matTooltipDisabled]="disabledTooltip(this.mobilePhone)">
          <mat-label i18n="@@type.Ranger.MobilePhone">Mobile Phone</mat-label>
          <input matInput formControlName="mobilePhone" id="mobilePhone" (ngModelChange)="mobilePhoneChanging($event)"
                 [(ngModel)]="item.mobilePhone" (ngModelChange)="mobilePhoneChanged($event)" #mobilePhone maxlength="20"
                 placeholder="Mobile Phone">
        </mat-form-field>
      </span>

      </div>
      <div class="crud-item-section" *ngIf="shouldPromptPoliceAddressChangeNotification()">
        <span>
          <button mat-raised-button color="primary" type="button" [disabled]="unsavedChanges()" (click)="notifyPoliceOfRangerAddressChange()">Notify Police of Address Change</button>
        </span>
      </div>
  </form>
</div>